import { MenuItemNested } from '@core/const';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { StateWithCore } from '../core-state';
import { getCustomCoreState } from './feature.selector';

export const getMenuNestedState: MemoizedSelector<
  StateWithCore,
  StateUtils.EntityLoaderState<MenuItemNested[]>
> = createSelector(getCustomCoreState, (state) => state.menusNested);

export const getMenuNested = (
  slug: string,
): MemoizedSelector<StateWithCore, StateUtils.LoaderState<MenuItemNested[]>> =>
  createSelector(getMenuNestedState, (state) => StateUtils.entityLoaderStateSelector(state, slug));

export const getMenuNestedValue = (slug: string): MemoizedSelector<StateWithCore, MenuItemNested[]> =>
  createSelector(getMenuNestedState, (state) => StateUtils.entityValueSelector(state, slug));

export const getMenuNestedLoading = (slug: string): MemoizedSelector<StateWithCore, boolean> =>
  createSelector(getMenuNestedState, (state) => StateUtils.entityLoadingSelector(state, slug));

export const getMenuNestedError = (slug: string): MemoizedSelector<StateWithCore, boolean> =>
  createSelector(getMenuNestedState, (state) => StateUtils.entityErrorSelector(state, slug));

export const getMenuNestedSuccess = (slug: string): MemoizedSelector<StateWithCore, boolean> =>
  createSelector(getMenuNestedState, (state) => StateUtils.entitySuccessSelector(state, slug));
